// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-3nN3N","button":"button-2kM4X","cancel":"cancel-2PGFI","close":"close-2R-OZ"};